// extracted by mini-css-extract-plugin
module.exports = {"reasonToSend":"headers_reasonToSend__22qSB","featureContent":"headers_featureContent__2WNNq","reason":"headers_reason__35Kfl","closeCollection":"headers_closeCollection__3jCIJ"};